import React, { useEffect, useRef, useState } from "react";

interface ServerStringFilterProps {
  onChange: (value?: string) => void;
}

const ServerStringFilter = ({ onChange }: ServerStringFilterProps) => {
  const [value, setValue] = useState<string>("");
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  //clear debounce timer
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    //add 500ms debounce
    debounceTimerRef.current = setTimeout(() => {
      onChange(newValue || undefined);
    }, 500);
  };

  // send request when enter
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      onChange(value || undefined);
    }
  };

  return (
    <input
      type="text"
      className={
        "w-100 h-100 px-2 rounded-pill " + // layout
        "bg-transparent " + // color
        "border-0 " // border
      }
      style={{ fontSize: "15px" }}
      placeholder="Suche..."
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  );
};

export default ServerStringFilter;
